import React, { useRef } from "react";

import { useTranslation } from "react-i18next";
import { Grid, useMediaQuery } from "@material-ui/core";
import { getStampTimeAndTimezone } from "../../../utils";
import "./dialog-sign.css";
import { newAnadirIconForButton } from "../../../assets/logos/icons/index";
import { ButtonHLPure, DialogTemplatePure } from "..";

const content = (props) => {
  const { t, cerRef, keyRef, mobileVersion } = props;
  const labelErrorUploadKeyCer = {
    color: "red",
    fontSize: "13px",
  };
  return (
    <>
      {props.userHasPfx === true &&
        props.userPfx !== "" &&
        props.userPfx !== null &&
        props.newSign === false ? (
        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          style={{ marginBottom: "20px" }}
        >
          <div className="alert-wrapper">
            <p className="alert-label-message">
              {t("dialogAcceptSignature.sign")}
            </p>
            <span className="alert-label-input">{props.userPfx}</span>
            {props.userPfx ? (
              <i
                className="k-icon k-i-check-circle k-i-checkmark-circle"
                style={{ fontSize: "25px", color: "#4F690C" }}
              ></i>
            ) : null}
          </div>
        </Grid>
      ) : (
        <Grid xs={12} lg={12} md={12} sm={12} es={12}>
          {/* Container Input key */}
          <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
            {/* <InputFileESignHLPure
                labelInputFile={t("dialogAcceptSignature.privateKey")}
                messageBtn={t("dialogAcceptSignature.fileKey")}
                acceptType={".key"}
                handleFileESignChange={props.handleFileKey}
                selectedFile={props.selectedFileKey}
                selectedFileName={props.selectedFileKeyName}
                errorFile={props.errorFileKey}
              /> */}

            <div className="dialog-files-container">
              <div className="dialog-files-wrapper">
                <p className="dialog-files-label">
                  {t("dialogAcceptSignature.privateKey")}
                </p>
                {/* <div className="dialog-input-file">
                  <img
                    className="k-icon"
                    src={newAnadirIconForButton}
                    alt="add-icon"
                    style={{ marginRight: "5px", width: '15px' }}
                  />
                  <input
                    type="file"
                    id="fileKey"
                    accept=".key"
                    onChange={(e) => {
                      props.handleFileKey(e);
                    }}
                    className="dialog-file"
                    required
                  />
                  <ButtonAddHLPure
                    nameBtn="Agregar alerta"
                  onClickBtn={() => setViewDetails(true)}
                  />
                </div> */}
                <label
                  onClick={() => keyRef.current.click()}
                  style={{
                    fontSize: "14px",
                    height: "27px",
                    padding: "2px 4px",
                    border: "2px solid #E3E4E8",
                    backgroundColor: "#E3E4E8",
                    borderRadius: "5px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                    fontSize: "18px",
                    letterSpacing: "0px",
                    color: "#2c353c",
                    opacity: 1,
                    fontFamily: "Quicksand",
                    fontWeight: 700,
                  }}
                >
                  <i className={"k-icon k-i-plus buttonAddHLPure-iconPlus-Style"}></i>
                  {!mobileVersion ? "Subir llave (.key)" : ".key"}
                </label>
                <input
                  ref={keyRef}
                  hidden
                  type="file"
                  accept=".key"
                  onChange={(e) => props.handleFileKey(e)}
                />
              </div>
              <div className="dialog-files-wrapper">
                <div className="dialog-input-file-leyend">
                  <span className="dialog-input-file-leyend-name">
                    {props.selectedFileKey === null
                      ? t("dialogAcceptSignature.validFile")
                      : `${props.selectedFileKeyName}`}
                  </span>
                </div>
                <span className="dialog-input-file-leyend-icon">
                  {props.selectedFileKey ? (
                    <i className="k-icon k-i-check-circle k-i-checkmark-circle"></i>
                  ) : null}
                </span>
              </div>
              {props.errorFileKey === true ? (
                <span style={labelErrorUploadKeyCer}>
                  {t("dialogAcceptSignature.validKey")}
                </span>
              ) : null}
            </div>
          </Grid>
          {/* Container Input cer */}
          <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
            {/* <InputFileESignHLPure
                labelInputFile={t("dialogAcceptSignature.certificate")}
                messageBtn={t("dialogAcceptSignature.fileCer")}
                acceptType={".cer"}
                handleFileESignChange={props.handleFileCer}
                selectedFile={props.selectedFileCer}
                selectedFileName={props.selectedFileCerName}
                errorFile={props.errorFileCer}
              /> */}

            <div className="dialog-files-container">
              <div className="dialog-files-wrapper">
                <p className="dialog-files-label">
                  {t("dialogAcceptSignature.certificate")}
                </p>
                <label
                  onClick={() => cerRef.current.click()}
                  style={{
                    fontSize: "14px",
                    height: "27px",
                    padding: "2px 4px",
                    border: "2px solid #E3E4E8",
                    backgroundColor: "#E3E4E8",
                    borderRadius: "5px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                    fontSize: "18px",
                    letterSpacing: "0px",
                    color: "#2c353c",
                    opacity: 1,
                    fontFamily: "Quicksand",
                    fontWeight: 700,
                  }}
                >
                  <i className={"k-icon k-i-plus buttonAddHLPure-iconPlus-Style"} />
                  {!mobileVersion ? "Subir certificado (.cer)" : ".cer"}
                </label>
                <input
                  ref={cerRef}
                  hidden
                  type="file"
                  accept=".cer"
                  onChange={(e) => props.handleFileCer(e)}
                />
              </div>
              <div className="dialog-files-wrapper">
                <div className="dialog-input-file-leyend">
                  <span className="dialog-input-file-leyend-name">
                    {props.selectedFileCer === null
                      ? t("dialogAcceptSignature.validFile")
                      : `${props.selectedFileCerName}`}
                  </span>
                </div>
                <span className="dialog-input-file-leyend-icon">
                  {props.selectedFileCer ? (
                    <i className="k-icon k-i-check-circle k-i-checkmark-circle"></i>
                  ) : null}
                </span>
              </div>

              {props.errorFileCer === true ? (
                <span style={labelErrorUploadKeyCer}>
                  {t("dialogAcceptSignature.validCertificate")}
                </span>
              ) : null}
            </div>
          </Grid>

          <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
            <div className="dialog-files-container">
              <div className="dialog-files-wrapper">
                <p className="dialog-files-label">{"Ingresa la contraseña"}</p>
                <div />
              </div>
              <div className="dialog-files-wrapper">
                <input
                  // value={props.passwordKey}
                  placeholder={t("changePasswordView.placeholderPassword")}
                  type="password"
                  onChange={(e) => props.setPassword(e.target.value)}
                  className="Dialog-accept-signature-electronica-dialog-file"
                  required
                />
                <div />
              </div>
            </div>
          </Grid>
        </Grid >
      )}
    </>
  );
};

/* === Dialog component Accept Signature === */
const OldDialogAcceptSignature = (props) => {
  const { t } = useTranslation();
  const cerRef = useRef(null), keyRef = useRef(null)
  const mobileVersion = useMediaQuery("(max-width:385px)")
  const adjustButtons = useMediaQuery("(max-width: 600px)")

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!props.selectedFileKey || !props.selectedFileCer) return;
    const stampTime = await getStampTimeAndTimezone()
    props.onSubmit("", "", stampTime);
  }

  return (
    <>
      {props?.signatureRequest?.signRequest?.signRequestStatus?.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING) ? (
        <>
          {props.authorizerCanSign &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_E_FIRMA) && (
              <ButtonHLPure
                nameBtn={"Autorizar"}
                primary
                onClickBtn={props.setIsShowAutorizationModal}
              />
            )}
          {props.userCanSign &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_E_FIRMA) && (
              <ButtonHLPure
                nameBtn={t("button.sign")}
                primary
                onClickBtn={props.toggleDialogAccept}
              />
            )}
          {props.visibleAccept &&
            !props.showLoadingRequesting &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_E_FIRMA) && (
              <div className="dialogContent">
                <DialogTemplatePure
                  title={t("dialogAcceptSignature.titleAcceptSignRequest", { signatureType: props.currentSignaturetype.name })}
                  description={<span>{t("dialogAcceptSignature.noticeCreateSignEFirma.pt1")} <strong>{t("dialogAcceptSignature.noticeCreateSignEFirma.esign")}</strong> {t("dialogAcceptSignature.noticeCreateSignEFirma.pt2")}</span>}
                  canelBtn={t("button.cancel")}
                  cancel={props.onDeleteDataAccept}
                  saveBtn={t("button.sign")}
                  handleSubmitProfile={onSubmit}
                  loadingComponent={props.showLoadingRequesting}
                  saveError={props.showErrorRequesting}
                  buttonCustomStyles={{ marginRight: adjustButtons ? "" : "10px" }}
                >
                  <div className={"base-dialog-padding"}>
                    {content({ ...props, cerRef, keyRef, mobileVersion, t })}
                  </div>
                </DialogTemplatePure>
              </div>
            )}
        </>
      ) : null}
    </>
  );
};

export { OldDialogAcceptSignature as default };